"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buildClassMap_1 = require("./buildClassMap");
exports.buildClassMap = buildClassMap_1.buildClassMap;
var icons_1 = require("./icons");
exports.getIcon = icons_1.getIcon;
exports.registerIcons = icons_1.registerIcons;
exports.registerIconAlias = icons_1.registerIconAlias;
exports.setIconOptions = icons_1.setIconOptions;
var getIconClassName_1 = require("./getIconClassName");
exports.getIconClassName = getIconClassName_1.getIconClassName;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib/utilities/index.js
// module id = 311
// module chunks = 0